import { useRef } from "react";
import { Tooltip } from "./Tooltip";

export function CircleButton({clickHandler, icon, tooltip='',disableAfterClick=false,color='text-white bg-indigo-500 hover:bg-indigo-600 hover:text-white'}) {
  const btnRef = useRef(null);
  
  return (
    <div className='relative group'>
      <button
        ref={btnRef}
        className={`${icon} ${color} fa-solid flex h-8 w-8 items-center justify-center rounded-full text-lg cursor-pointer`}
        onClick={(e) => {btnRef.current.disabled=disableAfterClick; clickHandler(e)}}
      />
      <Tooltip text={tooltip}></Tooltip>
    </div>
  ); 
}